<template>
  <el-dialog width="520px" title="生成激活码"  :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="copyAuthCodeVisible">
    <div class="details">
        <p>您购买的{{productName}}已生成如下</p>
        <h5>激活码：{{licenseCode}}</h5>
        <p>关闭此窗口后，可在系统通知或展开产品详情以查看此激活码</p>
    </div>
    <div slot="footer">
      <el-button  size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button  size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">复制激活码</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { } from '@/api/api'
import {mapState} from "vuex";
export default {
  name: 'copy_auth_code',
  props: {
    copyAuthCodeVisible: {
      type: Boolean,
      default: false,
    },
    licenseCode: {
      type: String,
      default: '',
    },
    productName: {
      type: String,
      default: '',
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
    }
  },

  created() {

  },
  computed: {
    ...mapState(['adminUserInfo']),

  },
  mounted() {

  },
  methods: {
    handleClickConfirm(){
      const textToCopy = this.licenseCode;
      const textarea = document.createElement('textarea');
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      // 选中文本并复制
      textarea.select();
      document.execCommand('copy');
      // 移除临时元素
      document.body.removeChild(textarea);
      this.$message({
        showClose: true,
        message: '复制成功',
        type: 'success',
        duration: 1500,
        onClose: () => { }
      });
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('success')
      this.$emit('update:copyAuthCodeVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>

.details p{
  line-height: 22px;
  margin-bottom: 16px;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
}
.details h5{
  line-height: 22px;
  margin-bottom: 16px;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
}
</style>
